import { useEffect, useState } from "react";
import axios from "axios";
import { errorHandeling } from "../../errorHandeling";
import { useSelector } from "react-redux";
import MainPageNoficationEval from "../MainPageNoficationEval/MainPageNoficationEval";
import apiUrl from "../../libs/baseUrl";

function ShouldEvalMyManager() {

  const token = useSelector(state => state.user.token)

//===State start here===

   //to show the evaluation nofication
   const [evalNotifi,setEvalNotifi] = useState(false); 
   
   const [error,setError] = useState('');

//===State end here===   

//===Event handler start here===

//fetch the data for the evaluation
 const fetchEvalouationData = async () => {

    try {

      const response = await axios.get(
        `${apiUrl}/manager-evaluations/should-evaluate-my-manager`,
     
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
 
      setEvalNotifi(response?.data?.data?.evaluate_my_manager);

  
    } catch (error) {
      console.error('Error:', error);
 
      setError(errorHandeling(error))
  
    }
  
  
  };


//===Event handler end here===

//===useEffect start here===

  useEffect(()=>{
    fetchEvalouationData();
  },[])

//===useEffect end here===  

  return (
    <>
    {
        (evalNotifi) &&
        (
            <MainPageNoficationEval 
            notifText={"يرجى تقييم المدير المباشر المسؤول عنك"}
            btnText = {"تقييم"}
            btnLink = {"/emp/eval_manager_by_emp"}
            error = {error}
            />
        )
    }

    </>
  )
}

export default ShouldEvalMyManager